module.exports = __webpack_public_path__ + "img/Icon ionic-ios-notifications.ebf5c89d.svg";